import { SF_COMMUNICATION } from "../constants";

const calculateContentHeight = (): number => {
  const offsetHeight =
    (document.getElementById("root")?.offsetHeight as number) ??
    SF_COMMUNICATION.IFRAME_HEIGHT;

  const scrollHeight =
    (document.getElementById("root")?.scrollHeight as number) ??
    SF_COMMUNICATION.IFRAME_HEIGHT;

  // In case of error/warning screen use scroll height instead of offset height
  return offsetHeight < SF_COMMUNICATION.IFRAME_HEIGHT
    ? scrollHeight
    : offsetHeight;
};

export const getMutationObserver = (
  setIFrameHeight: (height: number) => void
) => {
  const sendHeightToParent = () => {
    const contentHeight = calculateContentHeight();
    setIFrameHeight(contentHeight);
  };

  const observer = new MutationObserver(() => {
    sendHeightToParent();
  });

  // Observe changes in the body element
  observer.observe(document.body, {
    childList: true, // Detect addition/removal of child elements
    subtree: true, // Detect changes in all descendants
  });

  return observer;
};
